import pushClevertapEvent from './pushClevertapEvent';

export function signInFullSite() {
  pushClevertapEvent('Sign In Full Site');
}

export function switchToMweb() {
  pushClevertapEvent('Switch to mWeb');
}

export function switchToFullSite() {
  pushClevertapEvent('Switch to Full Site');
}

export function mWebAppsStart() {
  pushClevertapEvent('mWeb Apps Start');
}

export function mWebAppsCta() {
  pushClevertapEvent('mWeb Apps CTA');
}

export function mWebCapitalStart() {
  pushClevertapEvent('mWeb Capital Start');
}

export function mWebCapitalCta() {
  pushClevertapEvent('mWeb Capital CTA');
}
